import { Injectable } from '@angular/core';
import { Notification } from '../interfaces/notification';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NotificationSeenFrom } from '../enums/NotificationSeenFrom';
import { Pagination } from '../types/Pagination';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  prefix = `${environment.serverUrl}/notifications`;
  newNotification = new BehaviorSubject<Notification>(null);
  readNotificationId = new BehaviorSubject<string>(null);

  constructor(private http: HttpClient, private authService: AuthService) {}

  addNewNotification(notification: Notification | any) {
    if (this.isNotification(notification)) {
      this.newNotification.next(notification);
    }
  }

  isNotification(notification: Notification | any): boolean {
    if (!notification || !this.isValidNotification(notification)) return false;
    const { topic, body, createdAt, action, entity, entityId } = notification;
    return topic && body && createdAt && action && entityId && entity;
  }

  isValidNotification(notification: Notification) {
    const { topic } = notification;
    const tenantId = this.authService.getTenant().id;
    return topic === 'Marketplace' || topic.includes(tenantId);
  }

  async getNotification(pagination: Pagination): Promise<Notification[]> {
    const { currentPage, perPage } = pagination;
    const queryParams = [`currentPage=${currentPage}`, `perPage=${perPage}`];
    return await this.http.get<Notification[]>(`${this.prefix}?${queryParams.join('&')}`).toPromise();
  }

  async markNotificationAsRead(notificationId: string): Promise<{ success: boolean }> {
    return await this.http
      .put<{ success: boolean }>(`${this.prefix}/${notificationId}/read`, { seenFrom: NotificationSeenFrom.browser })
      .toPromise();
  }

  async markAllNotificationsAsRead(): Promise<{ success: boolean }> {
    return await this.http
      .put<{ success: boolean }>(`${this.prefix}/read`, { seenFrom: NotificationSeenFrom.browser })
      .toPromise();
  }
}
